import PlayingPlayersResponse from "../../models/player/PlayingPlayersResponse";
import axios from "axios";
import BackendClient from "../../BackendClient";
import playersResponse from "../../models/player/PlayersResponse";

export function getPlayingPlayers(client: BackendClient): Promise<PlayingPlayersResponse> {
    const headers = {
      'Authorization': `${client.getAuthEntity()} ${client.getAuthToken()}`,
    };

    return new Promise<PlayingPlayersResponse>((resolve, reject) => {
      axios.get(`${client.getBackendUrl()}${BackendClient.ListPlayingPlayers}`, {headers: headers})
        .then((response) => resolve(response.data))
        .catch((reason) => {
          console.log(`Exception when trying to get playing players: ${JSON.stringify(reason)}`)
          reject(reason);
        });
    });
  }